import { render, staticRenderFns } from "./JobsiteDetails.vue?vue&type=template&id=4b56486e&scoped=true"
import script from "./JobsiteDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobsiteDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JobsiteDetails.vue?vue&type=style&index=0&id=4b56486e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56486e",
  null
  
)

export default component.exports